<template>
    <div class="layout-wrapper">
        <div class="container-fluid">
            <div class="col-12">
                <div class="card shadow">
                    <div class="card-header  bg-accent-grad glow-accent text-center">
                        <h3 class="text-white">مدیریت کاربران/کارمندان</h3>

                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="card-header admin-header w-100">

                                <h5 class="text-accent-light">کاربران/کارمندان</h5>
                                <h5 class="text-accent-light" v-if="showArchive">(آرشیو شده)</h5>
                                <div class="text-left">
                                    <button class="btn btn-link text-accent-lightt"
                                            @click="onArchiveClicked()">
                                        <i class="fa fa-eye" v-if="showArchive" title="عدم نمایش آرشیو ها"></i>
                                        <i class="fa fa-eye-slash" v-else title="نمایش آرشیو ها"></i>
                                    </button>
                                    <button class="btn btn-link text-accent-light"
                                            @click="onAdduserClicked()"><i class="fa fa-plus"></i>
                                    </button>
                                </div>
                            </div>

                            <div class="col-12 input-group round mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">جستجو</span>
                                </div>
                                <input class="form-control" v-model="search" @input="searching()"
                                       placeholder="حداقل 2 کاراکتر از نام یا نام خانوادگی یا شماره موبایل یا شماره پرسنلی را وارد کنید">
                            </div>
                            <div class="table-responsive">
                                <div v-if="!isLoading">
                                    <preloader/>
                                </div>
                                <div v-else>
                                    <div v-if="myusers.length===0">
                                        <p class="text-center mt-3">هیچ کاربری ثبت نشده است. برای ثبت روی دکمه + کلیک
                                            کنید</p>

                                    </div>
                                    <div v-else>
                                        <table class="table table-hover table-striped mb-3">
                                            <thead>
                                            <tr>
                                                <th>نام کاربر/کارمند</th>
                                                <th>نام کاربری</th>
                                                <th>شماره پرسنلی</th>
                                                <th>موبایل</th>
                                                <th>نقش</th>
                                                <th>سرپرست</th>
                                                <th class="text-center">عملیات</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="it in myusers" :key="it.id">

                                                <td class="text-nowrap">{{it.fullName}}</td>
                                                <td class="text-nowrap">{{it.userName}}</td>
                                                <td class="text-nowrap">{{it.userCode}}</td>
                                                <td class="text-nowrap">{{it.mobile}}</td>
                                                <td class="text-nowrap">{{it.enRoleName}}</td>
                                                <td class="text-nowrap">{{it.manager}}</td>
                                                <td class="text-center text-nowrap"><i
                                                        class="fa fa-pencil-square-o px-3 clickable"
                                                        style="font-size: larger"
                                                        @click="editItem(it)"
                                                        title="ویرایش آیتم"></i>
                                                    | <i class="fa fa-trash-o px-3 clickable"
                                                         style="font-size: larger"
                                                         @click="deleteItem(it)"
                                                         title="حذف آیتم"></i>
                                                </td>

                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--///////////////////////////////////////////////////////////////////////////////////////////////////-->
            <modal show="false" ref="insertModal">
                <div class="row p-3">
                    <div class="col-12 text-center">
                        <h1 v-if="userMode === 'create'">ثبت کاربر/کارمند</h1>
                        <h1 v-else>ویرایش کاربر/کارمند</h1>
                    </div>
                    <div class="col-12 text-center">
                        <div class="profile-image">
                            <img :src="userModel.userNewImage" id="listImg" class="img-fluid" v-if="newImageCliked">
                            <img :src="validateImageUrl(userModel.userImage)" class="img-fluid" v-else>
                        </div>
                        <input type="file" id="fileUpload" class="d-none"
                               @change="onProfileImageChange($event)">
                        <label for="fileUpload" class="btn btn-info btn-round mb-3 clickable">بارگذاری
                            تصویر</label>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">کد پرسنلی</span>
                            </div>
                            <input class="form-control" v-model="userModel.userCode">
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">نام</span>
                            </div>
                            <input class="form-control" v-model="userModel.name">
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">نام خانوادگی</span>
                            </div>
                            <input class="form-control" v-model="userModel.family">
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">نام پدر</span>
                            </div>
                            <input class="form-control" v-model="userModel.fatherName">
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">جنسیت</span>
                            </div>
                            <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                       ref="userGender"
                                       :data="userGender"
                                       :mode="'create'"
                                       :selected-val="preselectedUserGender"
                                       :header="{multiple: false, label: 'name'}"
                                       aria-placeholder="جنسیت"
                                       @onChange="onProfileGenderChange"></vs-select>
                        </div>
                    </div>

                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">شماره بیمه</span>
                            </div>
                            <input class="form-control" v-model="userModel.insuranceCode">
                        </div>
                    </div>


                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">رشته تحصیلی</span>
                            </div>
                            <input class="form-control" v-model="userModel.field">
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">مدرک تحصیلی</span>
                            </div>
                            <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                       ref="evidence"
                                       :data="evidence"
                                       :mode="'create'"
                                       :selected-val="preselectedEvidence"
                                       :header="{multiple: false, label: 'title'}"
                                       aria-placeholder="مدرک تحصیلی"
                                       @onChange="onEvidenceChange"></vs-select>
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">شغل یا سمت</span>
                            </div>
                            <input class="form-control" v-model="userModel.semat" placeholder="مثلا: حسابدار">
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">شماره تلفن همراه</span>
                            </div>
                            <input class="form-control" v-model="userModel.mobile">
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">شماره ثابت</span>
                            </div>
                            <input class="form-control" v-model="userModel.phoneNumber">
                        </div>
                    </div>

                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">تاریخ تولد</span>
                            </div>
                            <date-picker type="date" format="jYYYY/jMM/jDD" @input="onCreateDatePicked"
                                         :auto-submit="true"
                                         ref="birthDay" style="flex: 1">
                                <slot>
                                    <input v-model="birthDay"
                                           class="form-control date-input flex-grow-1" readonly="true"
                                           @click="toggleCreateDatePicker">
                                </slot>
                            </date-picker>
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">استان</span>
                            </div>
                            <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                       ref="province"
                                       :data="provinces"
                                       :mode="'create'"
                                       :selected-val="preselectedUserProvince"
                                       :header="{multiple: false, label: 'name'}"
                                       aria-placeholder="استان"
                                       @onChange="onProfileProvinceChange"></vs-select>
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">شهر</span>
                            </div>
                            <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                       ref="city"
                                       :data="cities"
                                       :mode="'create'"
                                       :selected-val="preselectedUserCity"
                                       :header="{multiple: false, label: 'name'}"
                                       aria-placeholder="شهر"
                                       @onChange="onProfileCityChange"></vs-select>
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">کد ملی</span>
                            </div>
                            <input class="form-control" v-model="userModel.nationalCode">
                        </div>
                    </div>
                    <div class="col-lg-3 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">سرپرست</span>
                            </div>
                            <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                       ref="roles"
                                       :data="myusers"
                                       :mode="'create'"
                                       :selected-val="manager"
                                       :header="{multiple: false, label: 'fullName'}"
                                       aria-placeholder="انتخاب سرپرست"
                                       @onChange="onManagerChange"></vs-select>
                        </div>
                    </div>
                    <div class="col-lg-9 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">آدرس</span>
                            </div>
                            <input class="form-control" v-model="userModel.address">
                        </div>
                    </div>
                    <div class="col-lg-3 mb-4">
                        <div class="input-group round  text-center d-block">
                            <div class="input-group-prepend">
                                <span class="input-group-text">نام کاربری</span>
                                <input class="form-control" v-model="userModel.userName"
                                       placeholder="حتمن انگلیسی وارد کنید">
                            </div>
                            <!--<div class="text-right w-100 justify-content-center">-->
                            <small class="text-danger text-left">حتمن انگلیسی وارد کنید</small>
                            <!--</div>-->
                        </div>
                    </div>
                    <div class="col-lg-3 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">نقش - دسترسی</span>
                            </div>
                            <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                       ref="roles"
                                       :data="roles"
                                       :mode="'create'"
                                       :selected-val="preselectedRole"
                                       :header="{multiple: false, label: 'title'}"
                                       aria-placeholder="نقش - دسترسی"
                                       @onChange="onRoleChange"></vs-select>
                        </div>
                    </div>
                    <div class="col-lg-3 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">پسورد</span>
                            </div>
                            <input class="form-control" v-model="userModel.newpasswordHash"
                                   :placeholder="userModel.passwordHash != null ? 'کاربر پسورد دارد، درصورت تغییر پسورد جدید راوارد کنید' :'کاربر پسورد ندارد، لطفا وارد کنید'">
                        </div>
                    </div>
                    <div class="col-lg-3 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">ایمیل</span>
                            </div>
                            <input class="form-control" type="email" v-model="userModel.email">
                        </div>
                    </div>


                    <div class="col-12 text-center" v-if="userMode === 'edit'">
                        <hr/>
                        <div class="row">
                            <div class="col-4 mt-3"></div>
                            <div class="col-3 mt-3">
                                <h5>پایان قرارداد و آرشیو کردن اطلاعات</h5>
                            </div>
                            <div class="col-1 text-left  mt-3">
                                <toggle-button id="changed-font" class="m-0 ml-5"
                                               :color="{checked: '#297bf6', unchecked: '#90a4ae'}"
                                               :value="userModel.endCorporation"
                                               :sync="true" @change="onEndContractChange($event)"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 offset-lg-3 text-center">
                        <button class="btn btn-primary btn-round clickable mt-3" :disabled="isSending"
                                @click="updateuser" v-if="userMode==='edit'">ویرایش کاربر/کارمند
                        </button>
                        <button class="btn btn-primary btn-round clickable mt-3" :disabled="isSending"
                                @click="createuser" v-else>ثبت کاربر/کارمند
                        </button>
                        <button class="btn btn-success btn-round clickable mt-3 mx-3"
                                @click="canceluser">انصراف
                        </button>
                    </div>
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
    import BaseService from "../../_framework/api/BaseService";
    import DatePicker from '../../_framework/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from "../../_framework/VsSelect";
    import Utils from "../../_framework/utils/Utils";
    import Moment from 'moment-jalali';
    import Constants from "../../_framework/Constants";

    export default {
        name: "users",
        components: {VsSelect, DatePicker},
        data() {
            return {
                showArchive: false,
                isSending: false,
                isLoading: false,
                myusers: [],

                userMode: "",
                userModel: {
                    id: 0,
                    family: "",
                    name: "",
                    // birthCertificate: "",
                    userName: "",
                    birthday: "2020-11-13T14:51:43.919Z",
                    mobile: "",
                    nationalCode: "",
                    cityName: "",
                    cityId: 76,
                    provinceName: "",
                    provinceId: 5,
                    userImage: "",
                    userNewImage: "",
                    email: "",
                    // extension: "",
                    // mainJob: "",
                    fatherName: "",
                    address: "",
                    userCode: "",
                    insuranceCode: "",
                    field: "",
                    evidence: "",
                    semat: "",
                    phoneNumber: "",
                    passwordHash: "",
                    newpasswordHash: "",
                    enRole: "",
                    managerId:0,


                },
                preselectedUserGender: {},
                preselectedEvidence: {},
                preselectedUserProvince: {},
                preselectedUserCity: {},
                preselectedUserGenderId: 0,
                preselectedRole: {},
                preselectedUserProvinceId: 0,
                preselectedUserCityId: 0,
                evidence: [],
                userGender: [
                    {
                        name: "مرد",
                        value: true
                    },
                    {
                        name: "زن",
                        value: false
                    }
                ],
                cities: [],
                provinces: [],
                birthDay: "",
                newImageCliked: false,
                search: "",
                roles: [],
                manager:{},

            }
        },
        mounted() {
            this.getMyusers();
            this.getProvince();
            this.getEnEvidence();
            this.getRoles();
        },
        methods: {
            onArchiveClicked() {
                if (this.showArchive) {
                    this.showArchive = false;
                    this.getMyusers();
                } else {
                    this.showArchive = true;
                    this.newImageCliked = false;
                    new BaseService("user", "/GetArchiveUser").getList().then(response => {
                        this.myusers = response.data;
                        for(let i of this.myusers){
                            if(i.managerId != null || i.managerId != undefined){
                                for(let j of this.myusers) {
                                    if(i.managerId === j.id){
                                        i.manager = j.fullName;
                                    }
                                }
                            }
                        }
                        this.isLoading = true;
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                }
            },
            onEndContractChange(e) {
                const m = {
                    contractId: this.userModel.id,
                    ending: e.value
                };
                new BaseService("user", '/Enduser').update(m).then(response => {
                    if (e.value) {
                        this.$noty.success("کاربر/کارمند با موفقیت آرشیو شد و دیگر نشان داده نمیشود");

                    } else {
                        this.$noty.success("کاربر/کارمند با موفقیت بازیابی شد و نشان داده میشود");
                    }
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
                this.userModel.endCorporation = e.value;

            },
            getEnEvidence() {
                new BaseService("Enum", "/GetEnEvidence").getList().then(response => {
                    this.evidence = response.data;
                    this.isLoading = true;
                }).catch(error => {
                    console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getRoles() {
                new BaseService("enum", "/GetEnRole").getList().then(response => {
                    this.roles = response.data;
                }).catch(error => {
                    console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },

            getProvince() {
                new BaseService("State", "/GetStates").getList().then(response => {
                    this.provinces = response.data

                }).catch(error => {
                });
            },
            getCities(id) {
                new BaseService("State", `/GetCitiesOfState/${id}`).getList().then(response => {
                    this.cities = response.data;
                }).catch(error => {
                    console.log(error)
                });
            },
            onAdduserClicked() {
                this.userModel = {
                    id: 0,
                    family: "",
                    name: "",
                    // birthCertificate: "",
                    userName: "",
                    birthday: "2020-11-13T14:51:43.919Z",
                    mobile: "",
                    nationalCode: "",
                    cityName: "",
                    cityId: 76,
                    provinceName: "",
                    provinceId: 5,
                    userImage: "",
                    userNewImage: "",
                    email: "",
                    // extension: "",
                    // mainJob: "",
                    fatherName: "",
                    address: "",
                    userCode: "",
                    insuranceCode: "",
                    field: "",
                    evidence: "",
                    semat: "",
                    phoneNumber: "",
                    passwordHash: "",
                    newpasswordHash: "",
                    enRole: "",
                    managerId:0,
                };
                this.userMode = "create";
                this.preselectedUserGender={};
                this.preselectedEvidence={};
                this.birthDay="";
                this.preselectedUserProvince={};
                this.preselectedUserCity={};
                this.manager={};
                this.preselectedRole={};
                this.$refs.insertModal.showModal();
            },
            getMyusers() {
                new BaseService("user", "/Getuser").getList().then(response => {
                    this.myusers = response.data;
                    for(let i of this.myusers){
                        if(i.managerId != null || i.managerId != undefined){
                            for(let j of this.myusers) {
                                if(i.managerId === j.id){
                                    i.manager = j.fullName;
                                }
                            }
                        }
                    }
                    this.isLoading = true;
                    // console.log("Users",this.myusers)
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            editItem(item) {
                this.userModel = item;
                this.userMode = "edit";
                if (item.birthday != null) {
                    this.birthDay = Moment(this.gregorianToJalali(item.birthday), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                }
                if (item.male != null) {
                    if (item.male) {
                        this.preselectedUserGender = "مرد";
                        this.preselectedUserGenderId = true;
                    } else {
                        this.preselectedUserGender = "زن";
                        this.preselectedUserGenderId = false;
                    }
                }
                for (let ev of this.evidence) {
                    if (ev.value === item.evidence) {
                        this.preselectedEvidence = ev;
                    }
                }
                for (let ev of this.provinces) {
                    if (ev.id === item.provinceId) {
                        this.preselectedUserProvince = ev.name;
                        this.preselectedUserProvinceId = ev.id;
                    }
                }
                // console.log(item)
                for (let ev of this.roles) {
                    if (ev.value === item.enRole) {
                        this.preselectedRole = ev;
                    }
                }
                for (let ev of this.myusers) {
                    if (ev.id === item.managerId) {
                        this.manager = ev;
                    }
                }
                // console.log(this.roles)
                // console.log(item.enRole)
                // console.log(this.preselectedRole)
                // console.log(this.preselectedRoleId)
                if (item.cityId != null && item.provinceId != null) {
                    new BaseService("State", `/GetCitiesOfState/${item.provinceId}`).getList().then(response => {
                        this.cities = response.data;
                        for (let ev of this.cities) {
                            if (ev.id === item.cityId) {
                                this.preselectedUserCity = ev.name;
                                this.preselectedUserCityId = ev.id;
                            }
                        }
                    }).catch(error => {

                    });
                }
                this.$refs.insertModal.showModal();

            },
            deleteItem(item) {
                if (confirm("آیا از حذف این آیتم اطمینان دارید؟")) {
                    new BaseService("user", "Deleteuser").delete(item.id).then(response => {
                        this.$noty.warning("آیتم با موفقیت حذف شد");
                        this.getMyusers();
                    }).catch(error => {
                        Utils.handleErrorWithNotification("این آیتم در جای دیگری استفاده شده است، ابتدا موارد وابسته را پاک کنید", this.$noty);
                    })
                }
            },

            updateuser() {
                this.isSending = true;
                if (this.newImageCliked) {
                    let a = document.getElementById('listImg').src;
                    this.userModel.userImage = a.substring(a.indexOf(',') + 1, a.length);
                    this.newImageCliked = false;
                }

                if (this.userModel.cityId === undefined) {
                    this.userModel.cityId = this.preselectedUserCityId;
                }
                if (this.userModel.male === undefined) {
                    this.userModel.male = this.preselectedUserGenderId;
                }
                if (this.userModel.evidence === undefined) {
                    this.userModel.evidence = this.preselectedEvidenceId;
                }
                if (this.userModel.provinceId === undefined) {
                    this.userModel.provinceId = this.preselectedUserProvinceId;
                }
                // if (this.userModel.enRole === undefined) {
                //     this.userModel.enRole = this.preselectedRoleId;
                // }
                if (this.userModel.newpasswordHash != null && this.userModel.newpasswordHash !== "") {
                    if (this.userModel.newpasswordHash.length < 6) {
                        Utils.handleErrorWithNotification("پسورد حداقل باید 6 کاراکتر باشد", this.$noty);
                        this.isSending = false;
                    } else {
                        this.userModel.passwordHash = this.userModel.newpasswordHash;
                        this.userModel.phoneNumberConfirmed = true;
                        new BaseService("user", "/UpdateUser").update(this.userModel).then(response => {
                            this.isSending = false;
                            this.$noty.success("کاربر با موفقیت ویرایش شد");
                            this.userModel = {
                                id: 0,
                                family: "",
                                name: "",
                                // birthCertificate: "",
                                userName: "",
                                birthday: "2020-11-13T14:51:43.919Z",
                                mobile: "",
                                nationalCode: "",
                                cityName: "",
                                cityId: 76,
                                provinceName: "",
                                provinceId: 5,
                                userImage: "",
                                userNewImage: "",
                                email: "",
                                // extension: "",
                                // mainJob: "",
                                fatherName: "",
                                address: "",
                                userCode: "",
                                insuranceCode: "",
                                field: "",
                                evidence: "",
                                semat: "",
                                phoneNumber: "",
                                passwordHash: "",
                                newpasswordHash: "",
                                enRole: "",
                            };
                            this.manager = {};
                            this.$refs.insertModal.hideModal();
                            this.getMyusers();
                        }).catch(error => {
                            this.isSending = false;
                            Utils.handleErrorWithNotification(error.data, this.$noty);
                            // this.$refs.insertModal.hideModal();
                            // this.getMyusers();
                        });
                    }
                } else {
                    new BaseService("user", "/UpdateUser").update(this.userModel).then(response => {
                        this.isSending = false;
                        this.$noty.success("کاربر با موفقیت ویرایش شد");
                        this.userModel = {
                            id: 0,
                            family: "",
                            name: "",
                            // birthCertificate: "",
                            userName: "",
                            birthday: "2020-11-13T14:51:43.919Z",
                            mobile: "",
                            nationalCode: "",
                            cityName: "",
                            cityId: 76,
                            provinceName: "",
                            provinceId: 5,
                            userImage: "",
                            userNewImage: "",
                            email: "",
                            // extension: "",
                            // mainJob: "",
                            fatherName: "",
                            address: "",
                            userCode: "",
                            insuranceCode: "",
                            field: "",
                            evidence: "",
                            semat: "",
                            phoneNumber: "",
                            passwordHash: "",
                            newpasswordHash: "",
                            enRole: "",
                        };
                        this.manager = {};
                        this.$refs.insertModal.hideModal();
                        this.getMyusers();
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                        this.$refs.insertModal.hideModal();
                        this.getMyusers();
                    });
                }

            },
            createuser() {
                // console.log(this.userModel)
                this.isSending = true;
                if (this.newImageCliked) {
                    let a = document.getElementById('listImg').src;
                    this.userModel.userImage = a.substring(a.indexOf(',') + 1, a.length);
                    this.newImageCliked = false;
                }
                if (this.userModel.newpasswordHash.length < 6) {
                    this.isSending = false;
                    Utils.handleErrorWithNotification("پسورد حداقل باید 6 کاراکتر باشد", this.$noty);
                } else if (this.userModel.enRole === "" || this.userModel.enRole === null) {
                    this.isSending = false;
                    Utils.handleErrorWithNotification("نقش را انتخاب کنید", this.$noty);
                } else if (this.userModel.evidence === "" || this.userModel.evidence === null) {
                    this.isSending = false;
                    Utils.handleErrorWithNotification("مدرک تحصیلی را انتخاب کنید", this.$noty);
                } else if (this.userModel.userName === "" || this.userModel.evidence === null) {
                    this.isSending = false;
                    Utils.handleErrorWithNotification("نام کاربری را انتخاب کنید", this.$noty);
                } else {
                    if (this.userModel.newpasswordHash != null && this.userModel.newpasswordHash !== "") {
                        this.userModel.passwordHash = this.userModel.newpasswordHash;
                        this.userModel.phoneNumberConfirmed = true;
                        this.createeee();
                    } else {
                        this.createeee();
                    }

                }
            },
            createeee() {
                new BaseService("user", "/CreateUser").create(this.userModel).then(response => {
                    this.isSending = false;
                    this.$noty.success("کاربر با موفقیت ثبت شد");
                    this.userModel = {
                        id: 0,
                        family: "",
                        name: "",
                        // birthCertificate: "",
                        userName: "",
                        birthday: "2020-11-13T14:51:43.919Z",
                        mobile: "",
                        nationalCode: "",
                        cityName: "",
                        cityId: 76,
                        provinceName: "",
                        provinceId: 5,
                        userImage: "",
                        userNewImage: "",
                        email: "",
                        // extension: "",
                        // mainJob: "",
                        fatherName: "",
                        address: "",
                        userCode: "",
                        insuranceCode: "",
                        field: "",
                        evidence: "",
                        semat: "",
                        phoneNumber: "",
                        passwordHash: "",
                        newpasswordHash: "",
                        enRole: "",
                        managerId:0,
                    };
                    this.manager = {};
                    this.$refs.insertModal.hideModal();
                    this.getMyusers();
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    // this.$refs.insertModal.hideModal();
                    // this.getMyusers();
                });
            },
            canceluser() {
                this.$refs.insertModal.hideModal();
                this.getMyusers();
            },
            onCreateDatePicked(val) {
                this.birthDay = Moment(val, 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                this.userModel.birthday = this.jalaliToGregorian(val);
                /* let startDate = this.startPersianDate.split("/");
                 console.log(startDate);*/
            },
            toggleCreateDatePicker() {
                this.$refs.birthDay.togglePicker();
            },
            onProfileGenderChange(val) {
                if (val && val.value !== undefined) {
                    this.userModel.male = val.value;
                }
            },
            onEvidenceChange(val) {
                if (val && val.value !== undefined) {
                    this.userModel.evidence = val.value
                }
            },
            onProfileCityChange(val) {
                if (val && val.value !== undefined) {
                    this.userModel.cityId = val.id;
                    this.userModel.cityName = val.name;
                } else {
                    // this.competitionCity = []
                }

            },
            onProfileProvinceChange(val) {
                if (val && val.id) {
                    this.userModel.provinceId = val.id;
                    this.userModel.provinceName = val.name;
                    if (val.id !== undefined) {
                        this.getCities(val.id);
                    }
                } else {
                    this.cities = []
                }
            },
            onRoleChange(val) {
                if (val && val.value !== undefined) {
                    this.userModel.enRole = val.value;
                }
            },
            onManagerChange(val) {
                // console.log(val)
                if (val && val.name !== undefined) {
                    this.userModel.managerId = val.id;
                    this.manager = val;
                }else{
                    this.userModel.managerId =null;
                }
            },
            onProfileImageChange(e) {
                let files = e.target.files;
                let app = this;
                if (files && files[0]) {
                    this.newImageCliked = true;
                    for (let item of files) {
                        let extension = item.name.slice((item.name.lastIndexOf(".") - 1 >>> 0) + 2);
                        // if (extension === "jpg" || extension === "JPG" ||
                        //     extension === "png" || extension === "PNG" ||
                        //     extension === "JPEG" || extension === "jpeg") {
                        let reader = new FileReader();
                        reader.onload = function (e) {
                            // $("#bannerImg").attr("src", e.target.result);
                            let a = e.target.result;
                            let img = document.getElementById('listImg');
                            img.src = e.target.result;
                            app.userModel.userImage = a.substring(a.indexOf(',') + 1, a.length);
                            app.userModel.userNewImage = e.target.result;
                            app.userModel.extension = extension;
                        };
                        reader.readAsDataURL(item);
                        // } else {
                        //     alert("لطفا فایل عکس بارگذاری کنید");
                        // }
                    }
                }
            },
            validateImageUrl(img) {
                if (img !== undefined) {
                    return Constants.BASE_URL + "/" + img;
                }
            },
            searching() {
                if (this.search.length > 2) {
                    this.isLoading = false;
                    new BaseService("user", `/SearchUser/${this.search}`).getList().then(response => {
                        this.myusers = response.data;
                        for(let i of this.myusers){
                            if(i.managerId != null || i.managerId != undefined){
                                for(let j of this.myusers) {
                                    if(i.managerId === j.id){
                                        i.manager = j.fullName;
                                    }
                                }
                            }
                        }
                        this.isLoading = true;
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                } else {
                    this.getMyusers();
                }
            },

        }
    }
</script>

<style lang="scss" scoped>
    .profile-image {
        margin: 0 auto 1rem auto;
    }

    .profile-image img {
        max-width: 150px;
        border-radius: 1rem;
        box-shadow: 0 10px 25px -10px rgba(0, 0, 0, 0.25);
    }

    .loader,
    .loader:after {
        border-radius: 50%;
        width: 2.5em;
        height: 2.5em;
    }

    .loader {
        margin: 0 auto;
        font-size: 10px;
        position: relative;
        text-indent: -9999em;
        border-top: 0.25em solid rgba(255, 255, 255, 0.2);
        border-right: 0.25em solid rgba(255, 255, 255, 0.2);
        border-bottom: 0.25em solid rgba(255, 255, 255, 0.2);
        border-left: 0.25em solid #ffffff;
        -webkit-transform: translateZ(0);
        -ms-transform: translateZ(0);
        transform: translateZ(0);
        -webkit-animation: load8 1.1s infinite linear;
        animation: load8 1.1s infinite linear;
    }

    .loader.lg,
    .loader.lg:after {
        border-radius: 50%;
        width: 5em;
        height: 5em;
    }

    .loader.lg {
        margin: 60px auto;
        border-top: 0.5em solid rgba(255, 255, 255, 0.2);
        border-right: 0.5em solid rgba(255, 255, 255, 0.2);
        border-bottom: 0.5em solid rgba(255, 255, 255, 0.2);
        border-left: 0.5em solid #ffffff;
    }

</style>